import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var Stats = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Stats',
	};

	$.extend(true, this.options, options);

};

Stats.prototype.init = function() {

	var self = this;

	self.$stats = self.options.$el.find(`.${self.options.baseClass}__stat`);

	self.intlNumberFormatObject = new Intl.NumberFormat('en-US');

	self.initAnimation();

};

Stats.prototype.initAnimation = function() {

	var self = this;

	self.$stats.each(function() {

		let $stat = $(this);
		let $numbers = $(this).find(`.${self.options.baseClass}__stat__content__number`);
		let $number = $numbers.eq(0);
		let $secondNumber = $numbers.eq(1);
		let $scrollTrigger = $number.closest(`.${self.options.baseClass}__stat`);
		let targetNumber = $number.data('targetNumber');

		// let $prefix = $number.siblings(`.${self.options.baseClass}__stat__content__prefix`);
		let $suffix = $number.siblings(`.${self.options.baseClass}__stat__content__suffix`);

		console.log(targetNumber);

		let target = {
			val: 0
		};
		let decimals = (targetNumber + "").split(".").length > 1 ? 1 : 0;

		let timeline = gsap.timeline({
			scrollTrigger: {
				trigger: $scrollTrigger,
				start: "top+=72px bottom",
			},
		});

		// if ($prefix.length) {
		// 	timeline.to($prefix, {
		// 		duration: 0.5,
		// 		scale: 1,
		// 		opacity: 1,
		// 	});
		// }

		timeline.to($stat, {
			duration: 0.8,
			ease: "power3.out",
			y: 0,
			opacity: 1,
		})
		.to(target, {
			val: targetNumber,
			duration: 1.5,
			onUpdate: function () {
				let formattedNumber = self.intlNumberFormatObject.format(target.val.toFixed(decimals));
				$number.html(formattedNumber);
			},
		}, "<");

		if ($secondNumber.length) {
			let secondTargetNumber = $secondNumber.data('targetNumber');
			let secondTarget = {
				val: 0
			};
			timeline.to(secondTarget, {
				val: secondTargetNumber,
				duration: 1.5,
				onUpdate: function () {
					let formattedNumber = self.intlNumberFormatObject.format(secondTarget.val.toFixed(decimals));
					$secondNumber.html(formattedNumber);
				},
			}, "<");
		}

		if ($suffix.length) {
			timeline
			.to($suffix, {
				duration: 0.2,
				opacity: 1,
			}, ">=+0.1")
			.to($suffix, {
				duration: 0.3,
				scale: 1,
			}, "<");
		}

	});

};

export default Stats;
